module.exports = __webpack_public_path__ + "img/ton_handschrift_anim.ffea566a.png";